module.exports = __webpack_public_path__ + "static/media/banner2.e45d3a04.png";